import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface DetailHeaderBreadcrumb {
  label: string;
  route?: string;
}

export interface DetailHeaderConfig {
  title: string;
  updatedAt: string;
  breadcrumbs: DetailHeaderBreadcrumb[];
  /** When set (including empty string), replaces the “Published by” row — used on dataset/model detail pages. */
  shortDescription?: string;
  publishedBy?: string;
  /** Catalogue asset id — copied to clipboard (same behaviour as MahaAgX asset header). */
  assetId?: string;
}

@Component({
  selector: 'app-detail-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './detail-header.component.html',
  styleUrl: './detail-header.component.scss',
})
export class DetailHeaderComponent {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) config!: DetailHeaderConfig;
  /** When true, show like and bookmark controls (dataset / model detail). */
  @Input() showAssetActions = false;
  @Input() isLoggedIn = false;
  @Input() isBookmarked = false;
  @Input() isLiked = false;

  @Output() bookmarkClick = new EventEmitter<void>();
  @Output() likeClick = new EventEmitter<void>();
  @Output() loginRequired = new EventEmitter<void>();

  copySuccess = false;

  copyAssetId(): void {
    const id = this.config.assetId?.trim();
    if (!id) return;
    navigator.clipboard
      .writeText(id)
      .then(() => {
        this.copySuccess = true;
        this.cdr.markForCheck();
        setTimeout(() => {
          this.copySuccess = false;
          this.cdr.markForCheck();
        }, 2000);
      })
      .catch((err) => console.error('Failed to copy asset ID:', err));
  }

  onBookmarkClick(): void {
    if (!this.isLoggedIn) {
      this.loginRequired.emit();
      return;
    }
    this.bookmarkClick.emit();
  }

  onLikeClick(): void {
    if (!this.isLoggedIn) {
      this.loginRequired.emit();
      return;
    }
    this.likeClick.emit();
  }
}
